import Vue from 'vue'
import Router from './router/index.js'
import App from './App.vue'
import InstantSearch from 'vue-instantsearch'
import VModal from 'vue-js-modal'
import VueObserveVisibility from 'vue-observe-visibility'
 
Vue.config.productionTip = false
Vue.use(InstantSearch);
Vue.use(VModal);
Vue.use(VueObserveVisibility)

new Vue({
  router: Router,
  render: h => h(App),
}).$mount('#app')

// $(window).scroll(function () {
//   //set scroll position in session storage
//   sessionStorage.scrollPos = $(window).scrollTop();
//   });
//   var init = function () {
//   //return scroll position in session storage
//   $(window).scrollTop(sessionStorage.scrollPos || 0);
//   $(’.ap-dropdown-menu’).remove();
  
//   };
//   window.onload = init;